import { render } from "./PaymentDetails.vue?vue&type=template&id=f8fa9424&scoped=true&lang=pug"
import script from "./PaymentDetails.vue?vue&type=script&lang=ts"
export * from "./PaymentDetails.vue?vue&type=script&lang=ts"

import "./PaymentDetails.vue?vue&type=style&index=0&id=f8fa9424&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f8fa9424"

export default script